module.exports = __webpack_public_path__ + "static/logistic-model_fr-3a0541f852e566df2f85685b723c9261.svg";